export const UPDATE_STATEMENT_PROCESS_SUCCESS = 'UPDATE_STATEMENT_PROCESS_SUCCESS';

export const updateStatementProcessSuccess = processStatement => ({
    type: UPDATE_STATEMENT_PROCESS_SUCCESS,
    payload: { processStatement },
});
